import { quickStats } from "@/mocks/home";

export default function QuickStats() {
  return (
    <section className="relative z-20 -mt-14 md:-mt-20 px-4 md:px-8">
      <div className="max-w-6xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
        {quickStats.map((stat, index) => (
          <div
            key={stat.id}
            className={`flex flex-col items-center text-center gap-1 py-2 ${
              index !== quickStats.length - 1 ? "lg:border-r lg:border-background-200" : ""
            }`}
          >
            <span className="flex items-baseline gap-1">
              <span
                className={`font-heading font-bold text-xl md:text-2xl ${
                  index === 1 ? "text-primary-600" : "text-foreground-950"
                }`}
              >
                {stat.value}
              </span>
              {stat.unit && <span className="text-xs md:text-sm text-foreground-600">{stat.unit}</span>}
            </span>
            <span className="text-xs md:text-sm text-foreground-600">{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}